import React from "react"
import ClutchCard from "../../molecules/ClutchCard"
import ClutchBadge from "../../atoms/ClutchBadge"
import "./styles.scss"
import { Swiper, SwiperSlide } from "swiper/react"

import SwiperCore, { EffectFade, Pagination } from "swiper"
import designers_2020 from "../../../assets/images/homepage/top-web-designers-2020.png"
import global_2020 from "../../../assets/images/homepage/top-companies-global-2020.png"
import companies_2020 from "../../../assets/images/homepage/top-companies-2020.png"

import "swiper/swiper.scss"
import "swiper/components/effect-fade/effect-fade.scss"
SwiperCore.use([EffectFade, Pagination])

const ClutchSlider = ({ clutchReviews }) => {
  return (
    <section className="section section--clutchSlider">
      <div className="wrapper">
        <div className="wrapper--text">
          <Swiper
            pagination={{
              el: ".clutchSlider__pagination",
              clickable: true,
              renderBullet: function (index, className) {
                return (
                  '<span class="' + className + '">' + (index + 1) + "</span>"
                )
              },
            }}
            speed="1000"
            effect="fade"
          >
            {clutchReviews.map((review, i) => {
              return (
                <SwiperSlide key={i}>
                  <ClutchCard review={review} />
                </SwiperSlide>
              )
            })}
          </Swiper>
          <div className="clutchSlider__navigation">
            <div className="clutchSlider__pagination"></div>
            <div className="clutchSlider__badges">
              <ClutchBadge
                image={designers_2020}
                title="Top Global UX & web designers"
              />
              <ClutchBadge
                image={global_2020}
                title="Top 1000 global companies"
              />
              <ClutchBadge
                image={companies_2020}
                title="#1 web designers in poland"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ClutchSlider
